import { graphql, useStaticQuery } from 'gatsby'
import { useContext } from 'react'

import { APIEmployee } from '../../backend'
import { LocaleContext } from '../locale/i18n'
import { populateEmployeeWithContentfulData } from '../logic/employee'
import { ContentfulMember, TeamMemberPageLink } from '../logic/shared-types'

const useTeamMember = (email: string) => {
  const { locale } = useContext(LocaleContext)
  const { employees, teamMembers, teamMemberPageLinks } = useStaticQuery<{
    employees: {
      nodes: { employeeData: APIEmployee }[]
    }
    teamMembers: {
      nodes: ContentfulMember[]
    }
    teamMemberPageLinks: {
      nodes: TeamMemberPageLink[]
    }
  }>(graphql`
    query {
      employees: allEmployee {
        nodes {
          ...Employee
        }
      }
      teamMembers: allContentfulTeamMember {
        nodes {
          ...Member
        }
      }
      teamMemberPageLinks: allContentfulTeamMemberPage {
        nodes {
          ...TeamMemberPages
        }
      }
    }
  `)

  return (
    employees.nodes
      .map(e =>
        populateEmployeeWithContentfulData(
          teamMembers.nodes,
          e.employeeData,
          teamMemberPageLinks.nodes,
          locale,
        ),
      )
      .find(tm => tm?.email === email) ?? null
  )
}

export default useTeamMember
